export default [{
  mainButton: {
    name: 'reportsDays',
    label: 'Отчёты<br>по дням',
    goTo: '/reports/days',
    tooltip: ''
  },
  fastButtons: [{
    name: 'staffFilters',
    label: 'Фильтр графиков',
    goTo: '?modal=ReportsFilterModal'
  }, {
    name: 'uploadDownload',
    label: 'Загрузка и выгрузка данных',
    menu: [{
      name: 'download',
      label: 'Скачать сводный табель',
      goTo: '?modal=downloadReports-modalPivotTabel'
    }]
  }]
}, {
  mainButton: {
    name: 'reportsIndicators',
    label: 'Показатели',
    goTo: '/reports/indicators',
    tooltip: ''
  }
} // {
//   mainButton: {
//     name: 'download',
//     label: 'Скачать',
//     goTo: '?modal=downloadReports-modalPivotTabel',
//     tooltip: 'Скачать сводный табель'
//   }
// }
// {
//   mainButton: {
//     name: 'mbVacancy',
//     label: 'Отображение<br>по типам',
//     menu: [
//       { name: 'selectAll', label: 'Все', goTo: '?=all' },
//       { name: 'vacanciesFree', label: 'Только вакансии', goTo: '?mbVacancy=1' },
//       { name: 'vacanciesNotFree', label: 'Только смены <%shop_singular_R%>', goTo: '?mbVacancy=0' }
//     ]
//   }
// }
];